import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { BookOpenCheck, Save } from 'lucide-react';
import { toast } from 'sonner';

const SyllabusManagement = () => {
  const [syllabusText, setSyllabusText] = useState('');
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSyllabus();
  }, []);

  const fetchSyllabus = async () => {
    try {
      const response = await axios.get(`${API}/syllabus`);
      setSyllabusText(JSON.stringify(response.data, null, 2));
    } catch (error) {
      toast.error('Failed to load syllabus');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const parsed = JSON.parse(syllabusText);
      await axios.put(`${API}/admin/syllabus`, { data: parsed });
      toast.success('Syllabus updated successfully');
    } catch (error) {
      toast.error('Invalid JSON or failed to save syllabus');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]" data-testid="admin-syllabus-loading">
        <div className="text-lg text-slate-600">Loading syllabus...</div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="admin-syllabus-page">
      <div className="mb-8">
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-2">Syllabus Management</h1>
        <p className="text-lg text-slate-600">Update exam-wise subjects, chapters, and topics</p>
      </div>

      <Card className="border-0 shadow-xl">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <BookOpenCheck className="w-5 h-5 text-violet-600" />
            Syllabus JSON
          </CardTitle>
          <CardDescription>Edit the syllabus data in JSON format</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Textarea
            value={syllabusText}
            onChange={(e) => setSyllabusText(e.target.value)}
            className="min-h-[400px] font-mono text-sm"
            data-testid="admin-syllabus-textarea"
          />
          <Button
            onClick={handleSave}
            className="bg-violet-600 hover:bg-violet-700 text-white rounded-full"
            disabled={saving}
            data-testid="admin-syllabus-save-button"
          >
            <Save className="w-4 h-4 mr-2" />
            {saving ? 'Saving...' : 'Save Syllabus'}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default SyllabusManagement;